/**
 * Regulatory domain list (single source of truth).
 *
 * Imported by the homepage domain chip grid (pages/Landing.jsx) and by any
 * page that describes domain coverage (e.g., /mugenvip), so descriptions of
 * the twelve-domain sweep can never fall out of sync with the main site.
 */
export const REGULATORY_DOMAINS = [
  "Securities",
  "AML / KYC / Sanctions",
  "Custody & Safekeeping",
  "Tax",
  "Consumer Protection",
  "Market Integrity",
  "Data & Privacy",
  "Cybersecurity",
  "Commodities & Derivatives",
  "Banking & Payments",
  "Corporate & Governance",
  "IP & Smart Contracts",
];

/**
 * Prose form of a domain name for use inside sentences:
 * "AML / KYC / Sanctions" -> "AML, KYC and Sanctions"
 * "Custody & Safekeeping" -> "Custody and Safekeeping"
 */
export const domainProse = (name) => {
  const parts = name.split(" / ");
  const joined =
    parts.length > 1 ? `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}` : name;
  return joined.replace(/ & /g, " and ");
};
